import React, { useState } from "react";
import { Autocomplete, TextField, Popper, Paper, Typography } from "@mui/material";

// Normalize time input to uppercase and remove spaces
const normalizeTime = (time: string): string => {
  const cleaned = time.replace(/\s+/g, "");
  const match = cleaned.match(/^(\d{1,2}):(\d{2})(AM|PM)$/i);
  if (!match) return time;
  return `${match[1].padStart(2, "0")}:${match[2]} ${match[3].toUpperCase()}`;
};

// Custom Popper to scroll selected slot into view
const ScrollPopper = (props: any) => {
  setTimeout(() => {
    const selected = document.querySelector(
      '[role="listbox"] [aria-selected="true"]'
    ) as HTMLElement;
    if (selected) selected.scrollIntoView({ block: "center" });
  }, 0);

  return <Popper {...props} />;
};

interface TimePickerDropdownProps {
  value?: string;
  onChange: (val: string) => void;
  timeSlots?: string[];
}

const TimePickerDropdown: React.FC<TimePickerDropdownProps> = ({
  value,
  onChange,
  timeSlots,
}) => {
  const slots = timeSlots;
  const [inputValue, setInputValue] = useState(value || "");

  const handleInputChange = (event: any, newInputValue: string) => {
    const normalized = normalizeTime(newInputValue);
    setInputValue(normalized);
    if (!normalized.trim()) {
      onChange("");
      return;
    }
    onChange(normalized);
  };

  const handleChange = (event: any, newValue: string | null) => {
    if (!newValue) {
      const normalized = newValue ? normalizeTime(newValue) : "";
      onChange(normalized);
      setInputValue(normalized);
    }
  };

  return (
    <div>
      <Autocomplete
        disableClearable
        openOnFocus
        freeSolo
        options={slots}
        value={value}
        onChange={handleChange}
        onInputChange={handleInputChange}
        inputValue={inputValue}
        PopperComponent={ScrollPopper}
        disablePortal
        ListboxProps={{ style: { maxHeight: 140, overflowY: "auto" } }}
        PaperComponent={(props) => (
          <Paper
            {...props}
            style={{
              maxHeight: 140,
              overflowY: "auto",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              borderRadius: 8,
            }}
          />
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{ "& input": { height: 5, padding: "8px 12px" } }}
          />
        )}
      />
    </div>
  );
};

export default TimePickerDropdown;
